const dateFilterOptions = [
	{
		id: 1,
		value: 'last30Days',
		label: 'Last 30 Days',
	},
	{
		id: 2,
		value: 'last90Days',
		label: 'Last 90 Days',
	},
	{
		id: 3,
		value: 'last180Days',
		label: 'Last 180 Days',
	},
	{
		id: 4,
		value: 'last365Days',
		label: 'Last 365 Days',
	},
    {
		id: 5,
		value: 'custom',
		label: 'Custom Date Range',
	},
];

export { dateFilterOptions };



// WEBPACK FOOTER //
// ./src/common/constants/dateFilterOptions.js